module.exports = __webpack_public_path__ + "static/media/2-th.f8c54b9.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/audio/2-th.wav
// module id = ue4k
// module chunks = 1